import React from 'react';

const PageNumber = (props) => {
    const textColor = props.color ? '#fff' : '#362F7F';

    return(
        <div
            className="pagenumber__wrapper"
            style={{ color: textColor }}
        >
            <p className="pagenumber" style={{ color: textColor }}> { props.count } </p>
            <div className="pagenumber__circle--wrapper" style={{ color: textColor }}>
                <span className="pagenumber__circle" style={{ backgroundColor: textColor }}> </span>
            </div>
            <p className="pagenumber__text " style={{ color: textColor }}> { props.title } </p>
        </div>
    )
};

export default PageNumber;
